module.exports = __webpack_public_path__ + "static/media/map.1067693f.jpg";